import VolumeForecastGrid from "./VolumeForecastGrid";

const VolumeForecastTab = () => {
    return (
        <div className="container-fluid">
            <VolumeForecastGrid 
                gridHeight="70vh"
            />
        </div>
    );
};

export default VolumeForecastTab;
